import { DEFAULT_BALANCE } from './defaultBalance';
import { getCreditsState } from './getCreditsState';
import { getSubscriptionState } from './getSubscriptionState';
import { Balance } from './types';

export const getBalance = (balance?: Balance) => {
  if (!balance) {
    return DEFAULT_BALANCE;
  }

  const { credits, subscription } = balance;

  const subscriptionState = getSubscriptionState(subscription);
  const creditsState = getCreditsState(credits);

  return {
    ...subscriptionState,
    ...creditsState,
  };
};
